class OnboardingSessionManager {
	static ONBOARDING_KEY = 'onboardingActiveTreatment';
	static ONBOARDING_STATUS_KEY = 'onboardingStatus';

	static setActiveTreatment(data) {
		const fieldsToSave = {};

		if (data.diseaseUnique) fieldsToSave.diseaseUnique = data.diseaseUnique;
		if (data.diagnosisUnique) fieldsToSave.diagnosisUnique = data.diagnosisUnique;
		if (data.treatmentType) fieldsToSave.treatmentType = data.treatmentType;
		if (data.treatmentMethodCode) fieldsToSave.treatmentMethodCode = data.treatmentMethodCode;
		if (data.treatmentTypeName) fieldsToSave.treatmentTypeName = data.treatmentTypeName;

		if (Object.keys(fieldsToSave).length > 0) {
			sessionStorage.setItem(OnboardingSessionManager.ONBOARDING_KEY, JSON.stringify(fieldsToSave));
		}
	}

	static getActiveTreatment() {
		const raw = sessionStorage.getItem(OnboardingSessionManager.ONBOARDING_KEY);
		if (!raw) return {
			diseaseUnique: null,
			diagnosisUnique: null,
			treatmentType: null,
			treatmentMethodCode: null,
			treatmentTypeName: null,
		};
		return JSON.parse(raw);
	}

	static clearActiveTreatment() {
		const currentTreatment = OnboardingSessionManager.getActiveTreatment();
		const fieldsToKeep = {
			diseaseUnique: currentTreatment.diseaseUnique,
			diagnosisUnique: currentTreatment.diagnosisUnique,
		};

		if (Object.values(fieldsToKeep).some(value => value !== null)) {
			sessionStorage.setItem(OnboardingSessionManager.ONBOARDING_KEY, JSON.stringify(fieldsToKeep));
		} else {
			sessionStorage.removeItem(OnboardingSessionManager.ONBOARDING_KEY);
		}
	}

	static setOnboardingStatus(status) {
		sessionStorage.setItem(OnboardingSessionManager.ONBOARDING_STATUS_KEY, JSON.stringify(status));
	}

	static getOnboardingStatus() {
		const raw = sessionStorage.getItem(OnboardingSessionManager.ONBOARDING_STATUS_KEY);
		if (!raw) return null;
		return JSON.parse(raw);
	}

	static clearOnboardingStatus() {
		sessionStorage.removeItem(OnboardingSessionManager.ONBOARDING_STATUS_KEY);
	}
}

export default OnboardingSessionManager;
